module.exports = __webpack_public_path__ + "static/img/Plchdr.a24da43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Plchdr.png
// module id = 482
// module chunks = 10